import React from "react";
import cn from "classnames";
import * as styles from "./HeaderMenuDropdown.module.scss";
import MenuItemHeadline from "./MenuItemHeadline/MenuItemHeadline";
import MenuItemTile from "./MenuItemTile/MenuItemTile";
import TemplateSingleItem from "./TemplateSingleItem/TemplateSingleItem";

function SolutionsMenuDropdown() {
  return (
    <div className={styles.root}>
      <div className={styles.mainPartTiles}>
        <MenuItemHeadline>Tailored for your business</MenuItemHeadline>
        <div className={styles.mainTiles}>
          <MenuItemTile
            iconName={"rocket"}
            color={"#FF7E29"}
            name={"Product"}
            href={"/product-management"}
            description={"Turn customer insights into real products without breaking your flow."}
          />
          <MenuItemTile
            iconName={"cursor-ripple"}
            color={"#7646FF"}
            name={"Digital agency"}
            href={"/digital-agency"}
            description={"Collaborate with clients, manage projects, and connect work to a built-in CRM."}
          />
          <MenuItemTile
            iconName={"window-code"}
            color={"#0084FF"}
            name={"Software development"}
            href={"/software-development"}
            description={"Run sprints your way, manage tasks, and build a wiki that actually helps."}
          />
          <MenuItemTile
            iconName={"obj-3d-front"}
            color={"#13CF14"}
            name={"Startup"}
            href={"/startups"}
            description={"Invent, build, and grow — without drowning in tools you don’t need."}
          />
        </div>
      </div>
      <div className={styles.additionalPartLinks}>
        <div className={styles.additionalPartGroup}>
          <MenuItemHeadline>Looking for something different?</MenuItemHeadline>
          <div className={styles.mainTiles}>
            <MenuItemTile
              iconName={"ufo"}
              color={"#000000"}
              name={"Custom workspace"}
              href={"/sign-up"}
              description={"Design your perfect workspace from the ground up with no-code."}
            />
          </div>
        </div>
        <div className={styles.additionalPartGroup}>
          <MenuItemHeadline>Popular templates</MenuItemHeadline>
          <div className={styles.menuItemsGroup}>
            <div className={cn(styles.menuSingleItem, styles.itemWithIcon)}>
              <TemplateSingleItem
                iconConfig={{iconName: "ping-pong", fillColor: "black"}}
                templateName={"Retrospectives"}
                href={"/templates/retrospectives"}
                menuItem={true}
              />
            </div>
            <div className={cn(styles.menuSingleItem, styles.itemWithIcon)}>
              <TemplateSingleItem
                iconConfig={{iconName: "brain", fillColor: "black"}}
                templateName={"Meetings"}
                href={"/templates/meetings"}
                menuItem={true}
              />
            </div>
            <div className={cn(styles.menuSingleItem, styles.itemWithIcon)}>
              <TemplateSingleItem
                iconConfig={{iconName: "ball", fillColor: "black"}}
                templateName={"Product management"}
                href={"/templates/product-management"}
                menuItem={true}
              />
            </div>
          </div>

          <div className={styles.menuItemsGroup}>
            <div className={styles.menuSingleItem}>
              <a className={cn(styles.dropdownLink, styles.accent)} href="/templates">
                View templates gallery
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolutionsMenuDropdown;
